import usePrivateAxios from '@/common/api/usePrivateAxios'
import { MaintenanceWorkflowData } from '@/features/maintenanceWorkflow/types/maintenanceWorkflows.type';
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useMaintenanceWorkflow: (id: string | undefined) => UseQueryResult<MaintenanceWorkflowData, unknown> = (id) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: MaintenanceWorkflowData } }, unknown, MaintenanceWorkflowData>({
    enabled: !!id,
    queryKey: ['maintenanceWorkflow', id],
    queryFn: () => privateAxios.get(`/maintenance/workflows/${id}`),
    select: (data) => data?.data?.data,
  });
}
